import { WidgetWrapper } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';

export function PartnerNotImplementedWidget() {
  const { t } = useTranslate();

  return (
    <WidgetWrapper title={t('partner_not_implemented_title')}>
      <p>{t('partner_not_implemented_text')}</p>
    </WidgetWrapper>
  );
}
